import { createStyles, makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'
import colors from 'shared/style/colors'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    article: { textAlign: 'center' },
    image: {
      marginBottom: '1rem',
      boxShadow: `0.08rem 0.08rem 0.2rem ${colors.highlightable}`,
      '&:hover': {
        boxShadow: `0.15rem 0.15rem 0.25rem ${colors.hoverHighlightable}`
      }
    },
    subtitle: { marginBottom: '.25rem' },
    title: {
      fontFamily: 'Montserrat !important',
      textTransform: 'none'
    },
    paragraph: {
      fontFamily: 'Montserrat !important'
    },
    draft: {
      height: '2rem',
      width: '100%',
      backgroundColor: 'rgb(234, 245, 255)',
      color: 'rgb(12, 117, 175)',
      fontWeight: 'bold',
      fontFamily: 'Montserrat !important',
      padding: '4px 8px',
      border: '1px solid rgb(184, 225, 255)',
      borderRadius: '4px'
    }
  })
)
